module.exports = __webpack_public_path__ + "img/img6.1064d786.jpg";